export const decodeJWTToken = (token) => {
    let payload = {
        expirationTime: 0,
        givenName: '',
        issuedAt: 0,
        identityType: '',
        issuer: '',
        jwtId: '',
        subject: ''
    };
    try {
        const { exp: expirationTime, given_name: givenName, iat: issuedAt, identity_type: identityType, iss: issuer, jti: jwtId, sub: subject } = JSON.parse(atob(token.split('.')[1]));
        payload = {
            expirationTime,
            givenName,
            issuedAt,
            identityType,
            issuer,
            jwtId,
            subject
        };
        return payload;
    }
    catch (error) {
        window.console.error(error);
        return payload;
    }
};
export default decodeJWTToken;
